// Removed incorrect import of Error icon
import { signInWithCustomToken } from "firebase/auth";
import { authService } from "../../firebase-config";
import { platformTool } from "../../utils/PlatformTool";
import { soulApi } from "../api/SoulApi";
import {
  SoulDataModel,
  UpdateSoulInfoPayload,
} from "../models/soul/SoulDataModel";
import { SoulLoginParams } from "../models/soul/SoulLoginParams";

class SoulManager {
  private static instance: SoulManager;

  public static get(): SoulManager {
    if (!this.instance) {
      this.instance = new SoulManager();
    }
    return this.instance;
  }

  async loginWithEmail({
    email,
    password,
  }: {
    email: string;

    password: string;
  }): Promise<boolean> {
    const result = await soulApi.soulAuth.request({
      email,
      password,
    });
    if (!result?.isSuccess) {
      throw new Error(result?.messageError ?? "Error on check email code");
    }
    const deviceData = await platformTool.getDeviceData();
    await signInWithCustomToken(authService, result.data?.token!);
    const token = await authService.currentUser!.getIdToken();
    const data: SoulLoginParams = {
      userId: result.data?.uid!,
      deviceData,
      email,
      customToken: token,
    };
    await this.sendLoginDataToBackend(data);
    return true;
  }

  private async sendLoginDataToBackend(
    params: SoulLoginParams
  ): Promise<boolean> {
    const result = await soulApi.soulLogin.request(params);
    if (result.isSuccess) {
      return true;
    }
    return false;
  }

  async getSoul(): Promise<SoulDataModel | undefined> {
    try {
      const result = await soulApi.soulInfo.request(null);
      return new SoulDataModel(result.data);
    } catch (error) {
      console.error("Error en getSoul:", error);
      return undefined;
    }
  }

  async updateSoulInfo(
    payload: UpdateSoulInfoPayload
  ): Promise<SoulDataModel | undefined> {
    try {
      const result = await soulApi.updateSoulInfo.request(payload);
      return new SoulDataModel(result.data);
    } catch (error) {
      console.error("Error en getSoul:", error);
      return undefined;
    }
  }

  async getAllSouls(): Promise<SoulDataModel[] | undefined> {
    try {
      const result = await soulApi.allSoulsInfo.request(null);
      const soulsArray = Array.isArray(result.data)
        ? result.data
        : [result.data];
      const mappedSouls = soulsArray.map(
        (item: any) => new SoulDataModel(item)
      );
      return mappedSouls;
    } catch (error) {
      console.error("❌ Error en getAllSouls:", error);
      return undefined;
    }
  }
}

export const soulManager = SoulManager.get();
